module.exports = __webpack_public_path__ + "ae450ebcbd0043193f5c9b097af04e54.svg";